import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  ConnectorOptionDto,
  RevShareConfigDto,
  RevShareConfigFilterInput,
  RevShareProfileOptionDto,
  RevShareReportInput,
  RevShareReportResultDto,
  SaveRevShareConfigInput,
  UpdateRevShareConfigInput,
} from '@/api/types/revenueShare';

const DEALS = '/api/app/rev-share-deals';
const RESULTS = '/api/app/rev-share-results';

export const revShareDealsApi = {
  getList: (input: RevShareConfigFilterInput) =>
    http.get<PagedResult<RevShareConfigDto>>(DEALS, { params: input }).then((r) => r.data),
  getConnectors: () => http.get<ConnectorOptionDto[]>(`${DEALS}/connectors`).then((r) => r.data),
  create: (input: SaveRevShareConfigInput) => http.post(DEALS, input).then((r) => r.data),
  update: (input: UpdateRevShareConfigInput) => http.put(DEALS, input).then((r) => r.data),
  remove: (id: number) => http.delete(`${DEALS}/${id}`).then((r) => r.data),
};

export const revShareResultsApi = {
  getProfiles: () => http.get<RevShareProfileOptionDto[]>(`${RESULTS}/profiles`).then((r) => r.data),
  getYears: () => http.get<number[]>(`${RESULTS}/years`).then((r) => r.data),
  getReport: (input: RevShareReportInput) =>
    http.get<RevShareReportResultDto>(`${RESULTS}/report`, { params: input }).then((r) => r.data),
};
